"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _InspirationsHeader = _interopRequireDefault(require("../../../InspirationsHeader"));

require("./styles/_bookmarked-posts-header.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var BookmarkedPostsHeader = function BookmarkedPostsHeader(props) {
  var getInspirationsHeader = props.getInspirationsHeader,
      selectedInspirationOrgId = props.selectedInspirationOrgId,
      history = props.history,
      isFeatured = props.isFeatured;
  return _react.default.createElement(_InspirationsHeader.default, {
    getInspirationsHeader: getInspirationsHeader,
    className: "bookmarked-posts-header",
    selectedInspirationOrgId: selectedInspirationOrgId
  }, _react.default.createElement(_uiKit.PageHeader, {
    title: "".concat(isFeatured ? 'Featured' : 'Favourite', " Posts"),
    subtitle: "Inspiration",
    subtitleLink: "/inspiration",
    history: history
  }));
};

var _default = (0, _react.memo)(BookmarkedPostsHeader);

exports.default = _default;